import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { globalStyles } from "../../views/Resume";
import Title from "./Title";
import { education } from "../../constants/resume";

const styles = StyleSheet.create({
  school: {
    fontFamily: "Lato Bold",
    fontSize: 6,
  },
  degree: {
    fontFamily: "Lato",
    fontSize: 6,
  },
  candidate: {
    fontFamily: "Lato Italic",
    fontSize: 5,
  },
});

const Education = () => (
  <View style={globalStyles.container}>
    <View>
      <Title>Education</Title>
    </View>
    <Text style={styles.school}>{education.institute}</Text>
    <Text style={styles.degree}>{education.degree}</Text>
    <Text style={styles.candidate}>{education.batch}</Text>
  </View>
);

export default Education;
